// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_string = require("rescript/lib/js/js_string.js");
var JsxRuntime = require("react/jsx-runtime");
var Project$ReactHooksTemplate = require("./project.res.js");
var ModalFormLayout$ReactHooksTemplate = require("./ModalFormLayout.res.js");

function ProjectForm(props) {
  var onSubmit = props.onSubmit;
  var selectedProject = props.selectedProject;
  var toggleProjectForm = props.toggleProjectForm;
  var match = React.useState(function (param) {
        return selectedProject;
      });
  var setProject = match[1];
  var project = match[0];
  var match$1 = React.useState(function (param) {
        return false;
      });
  var setErrors = match$1[1];
  var errors = match$1[0];
  var containsInvalidChar = function (specialCharRegex, words) {
    return List.exists((function (word) {
                  return List.exists((function (x) {
                                return Caml_obj.equal(word, x);
                              }), specialCharRegex);
                }), words);
  };
  var handleNameChange = function (e) {
    var name = e.target.value;
    var words = Belt_List.fromArray(Js_string.split("", name));
    var error = containsInvalidChar({
          hd: "<",
          tl: {
            hd: "!",
            tl: {
              hd: "=",
              tl: {
                hd: "+",
                tl: {
                  hd: "-",
                  tl: {
                    hd: "@",
                    tl: {
                      hd: ">",
                      tl: {
                        hd: "?",
                        tl: {
                          hd: "'",
                          tl: {
                            hd: "\"",
                            tl: {
                              hd: "$",
                              tl: {
                                hd: "#",
                                tl: {
                                  hd: "%",
                                  tl: {
                                    hd: "^",
                                    tl: {
                                      hd: "*",
                                      tl: {
                                        hd: "(",
                                        tl: {
                                          hd: ")",
                                          tl: {
                                            hd: "/",
                                            tl: {
                                              hd: ".",
                                              tl: {
                                                hd: "&",
                                                tl: {
                                                  hd: ",",
                                                  tl: {
                                                    hd: ";",
                                                    tl: {
                                                      hd: "`",
                                                      tl: {
                                                        hd: "~",
                                                        tl: /* [] */0
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }, words);
    Curry._1(setErrors, (function (param) {
            return error;
          }));
    Curry._1(setProject, (function (prev) {
            return Project$ReactHooksTemplate.setName(prev, name);
          }));
  };
  var canSave = Project$ReactHooksTemplate.name(project).length !== 0 && !errors;
  return JsxRuntime.jsx(ModalFormLayout$ReactHooksTemplate.Shell.make, {
              body: JsxRuntime.jsx(ModalFormLayout$ReactHooksTemplate.ProjectNameField.make, {
                    name: Project$ReactHooksTemplate.name(project),
                    nameError: errors,
                    onNameChange: handleNameChange
                  }),
              footer: JsxRuntime.jsx(ModalFormLayout$ReactHooksTemplate.make, {
                    onDiscard: (function (param) {
                        Curry._1(toggleProjectForm, undefined);
                      }),
                    onPrimary: (function (param) {
                        Curry._1(onSubmit, project);
                      }),
                    primaryLabel: "Save",
                    primaryDisabled: !canSave
                  })
            });
}

var make = ProjectForm;

exports.make = make;
/* react Not a pure module */
